
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>«Ich habe Angst»</h4>
    <p>
  Das Solothurner Amt für Justizvollzug ordnet an, dass sich William W. in einem geschützten Wohn- und Arbeitsrahmen
  aufzuhalten hat. Regelmässig muss er zum Gespräch mit der Bewährungshilfe und in die psychiatrische Therapie gehen.
  Der Kinderschänder hat seine Abstinenz mit Drogen- und Alkoholtests nachzuweisen. Das geht aus dem geheimen
  Untersuchungsbericht zum Fall hervor. Weiter heisst es: «Zudem wurde die elektronische Überwachung mittels GPS-Gerät
  angeordnet.» W. muss eine Fussfessel tragen, damit die Behörden seine Bewegungen nachvollziehen können. Das soll ihn
  von weiteren Taten abhalten.
    </p>
    <p>
  Die mittlerweile 18-jährige Selina, die dem Mann zehn Jahre zuvor in der Baubaracke zum Opfer fiel, ist trotzdem
  skeptisch. Als die SonntagsZeitung publik macht, dass ihr Peiniger auf freien Fuss kommt, sagt sie: «Ich habe Angst.
  Angst, dass er mir wieder etwas antut. Oder einem anderen Kind.»
    </p>
    <Image file={require('images/sonntagszeitung.png')} source='Bericht der SonntagsZeitung zur Entlassung von W. (RD)' mdxType="Image" />
    <p>
  Ab 15. November 2016 ist William W. ein freier Mann. Er kommt in einem betreuten Wohnheim bei Olten unter. Wenige
  Kilometer vom Ort, in dem er sich 2006 an Selina vergangen hatte. Und keine 500 Meter entfernt von einem Kinderheim.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;